export default __webpack_public_path__ + "static/media/BS06.2326020c.jpg";